var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popover',{ref:"popover",attrs:{"showHeader":true,"headerTitle":_vm.title,"sizeClass":"popover-medium"}},[_c('LoadingPanel',{ref:"loadingPanel"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }